import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../components/customAxios/Axios";
import logo from "@/assets/talentickaiwhite.webp";
import logo2 from "@/assets/talentick.ai.webp";
import { useLoader } from "../context/loaderContext";
import { useToast } from "../components/toast";
import authPhoto from "@/assets/auth.webp";

const ForgetPass: React.FC = () => {
	const { setLoading } = useLoader();
	const [email, setEmail] = useState("");
	const toast = useToast();

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		try {
			setLoading(true);
			const res = await api.post("/forgot_password", { email: email });

			if (res.status === 200)
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Email Sent",
					description:
						"Reset password link has been sent to your registered mail.",
					open: true,
				});
			else
				toast.error({
					type: "background",
					duration: 3000,
					status: "Error",
					title: "Error",
					description: res.data?.error || res.data?.message,
					open: true,
				});
		} catch (err: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error",
				description: err.response?.data?.error || err.response?.data?.message,
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="mx-auto flex flex-col md:flex-row items-center gap-8 bg-white">
			{/* Mobile Logo */}
			<div className="w-full block md:hidden mb-6">
				<Link to="/" className="flex gap-2 items-center fixed top-10">
					<svg width="20" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M10.0154 0.733154L4.23065 6.51518C3.93728 6.79466 3.93728 7.23137 4.23065 7.51085L10.0155 13.2928"
							stroke="#7F7F7F"
							strokeMiterlimit="2.613"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
					<img src={logo2} className="h-5" alt="Logo" />
				</Link>
			</div>

			{/* Left Side - Image and Text */}
			<div className="relative w-[55%] h-screen hidden md:block">
				<img
					src={authPhoto}
					alt="Background"
					className="w-full h-screen object-cover shadow-md"
				/>
				<div className="absolute inset-0 opacity-40 h-screen bg-[#32413D]"></div>

				{/* Logo */}
				<Link to="/">
					<img
						src={logo}
						className="absolute top-8 left-8 max-h-10 cursor-pointer z-50"
						alt="Logo"
					/>
				</Link>

				{/* Centered Text Box */}
				<div className="absolute inset-0 flex flex-col items-center justify-center px-8">
					<div className="bg-white/30 backdrop-blur-[70px] rounded-lg p-8 md:p-10 w-full max-w-[650px] text-white">
						<h2 className="text-2xl lg:text-5xl font-bold mb-4">
							Smarter Hiring Made Simple
						</h2>
						<p className="text-sm md:text-lg font-light">
							Experience a new era of recruitment with talentick.ai, where AI simplifies hiring automatically generating assessments, scoring resumes, and helping you find the right candidates faster. Get started today!
						</p>
					</div>
				</div>

				{/* Bottom text */}
				<div className="absolute bottom-8 w-full text-center text-white text-sm lg:text-base font-light">
					Secure access to your account
				</div>
			</div>

			{/* Right Side - Forgot Password Form */}
			<div className="w-full md:w-[40%] overflow-auto md:px-0 px-4">
				<div className="flex flex-col items-center justify-center py-4">
					<div className="w-full">
						<h2 className="text-2xl md:text-3xl font-bold text-center text-zinc-800 mb-6">
							Forgot your Password
						</h2>

						<p className=" text-zinc-600 dark:text-zinc-300 mb-8">
							Please enter the email address where you'd like your password reset information to be sent.
						</p>						<form onSubmit={handleSubmit} className="space-y-6">
							<div>
								<label className="block text-sm font-medium text-zinc-700 mb-1">
									Email
								</label>
								<input
									type="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									className="w-full border border-gray-300 rounded-lg py-3 px-4 text-zinc-700 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
									placeholder="Enter your email"
									required
								/>
							</div>

							<button
								type="submit"
								className="w-full bg-[#162D3A] text-white font-semibold py-3 px-4 rounded-lg hover:bg-[#0e1c24] transition-colors duration-200 flex items-center justify-center"

							>
								Reset Password
							</button>

							<p className="text-center text-sm text-zinc-600 mt-6">
								Remember your password?{" "}
								<Link
									to="/login"
									className="text-blue-500 font-medium hover:text-blue-700 transition-colors"
								>
									Login
								</Link>
							</p>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ForgetPass;
